import { useEffect } from 'react';

interface PageTitleProps {
  title: string;
  children: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, children }) => {
  useEffect(() => {
    const baseTitle = 'ShiYou';
    const fullTitle = title ? `${baseTitle} - ${title}` : baseTitle;
    document.title = fullTitle;
    
    // Update meta description for better SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      const description = title 
        ? `Find your perfect roommate with ShiYou. ${title}. AI-powered matching for compatible living in NYC and Jersey City.`
        : 'Find your perfect roommate with ShiYou. AI-powered matching for compatible living. Join thousands of students finding ideal roommates in NYC and Jersey City.';
      metaDescription.setAttribute('content', description);
    }
    
    // Update Open Graph meta tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', fullTitle);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      const ogDesc = title
        ? `Find your perfect roommate with ShiYou. ${title}. AI-powered matching for compatible living.`
        : 'Find your perfect roommate with AI-powered matching. Join thousands of students in NYC and Jersey City.';
      ogDescription.setAttribute('content', ogDesc);
    }
    
    // Update Twitter meta tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', fullTitle);
    }
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      const twitterDesc = title
        ? `Find your perfect roommate with ShiYou. ${title}.`
        : 'Find your perfect roommate with AI-powered matching.';
      twitterDescription.setAttribute('content', twitterDesc);
    }
  }, [title]);

  return <>{children}</>;
};

export default PageTitle;
